import '@algolia/autocomplete-theme-classic';

import { autocomplete } from '@algolia/autocomplete-js';

export default () => ({
  trackSystemAutocomplete: null,
  partNumberAutocomplete: null,
  currentYears: [],
  selectedModel: null,
  selectedYear: null,
  assemblies: [],
  part: null,
  loading: false,
  currentQuery: '',
  modelSelect: null,
  yearSelect: null,
  modelQuery: '',
  partQuery: '',
  listTitle: '',
  quantity: 1,
  filterQuery: '',
  init() {
    this._initAutocomplete();
    this._initDropDowns();

    const submitButton = document.getElementById('submit-button');

    // get url params for model and part
    const urlParams = new URLSearchParams(window.location.search);
    const modelParam = urlParams.get('model');
    const partParam = urlParams.get('part');

    if (modelParam && modelParam !== 'null') {
      this._fetchAssemblies(modelParam);
      this.$nextTick(() => {
        // console.log('setting model param', modelParam.substring(modelParam.indexOf(' ') + 1));
        this.modelSelect.value = this._getModelName(modelParam);
        this.currentYears = JSON.parse(this.modelSelect.options[this.modelSelect.options.selectedIndex].dataset.years || '[]');
        setTimeout(() => {
          this.yearSelect.value = modelParam;
        }, 100);
      });
    }

    if (partParam && partParam !== 'null') {
      this._fetchPartAssemblies(partParam);
      this.partQuery = partParam;
      this.currentQuery = partParam;
      this.$nextTick(() => {
        this.partNumberAutocomplete.setQuery(partParam);
      });
    }
    
    submitButton.addEventListener('click', () => {
      this._fetchAssemblies(this.modelQuery);
      this.trackSystemAutocomplete.setQuery('');
      this.partNumberAutocomplete.setQuery('');
    });
  },
  getAssemblyUrl(assembly){
    return assembly.url+`?model=${this.modelQuery}&part=${this.partQuery}`;
  },
  filterAssemblies(){
    const query = this.filterQuery.toLowerCase();
    this.assemblies.forEach(assembly => {
      const partsData = assembly.parts.join(' ').toLowerCase();
      if(partsData.includes(query) || assembly.title.toLowerCase().includes(query)){
        assembly.visible = true;
      } else {
        assembly.visible = false;
      }
    });
  },
  clearFilter(){
    this.filterQuery = '';
    this.assemblies.forEach(assembly => {
      assembly.visible = true;
    });
  },
  _getModelName(value) {
    return value.substring(value.indexOf(' ') + 1)
  },
  _initDropDowns() {
    this.modelSelect = document.getElementById('model-dd');
    this.yearSelect = document.getElementById('year-dd');

    this.modelSelect.addEventListener('change', (event) => {
      const selectedOption = event.target.options[event.target.selectedIndex];
      this.currentYears = JSON.parse(selectedOption.dataset.years || '[]');
      this.selectedModel = null;
      this.$nextTick(() => {
        this.selectedModel = this._getModelName(this.currentYears[0]?.value);
        this.modelQuery = this.currentYears[0]?.value;
      });
    });

    this.yearSelect.addEventListener('change', (event) => {
      this.selectedModel = this._getModelName(event.target.value);
    });

  },
  _initAutocomplete() {
    this._destroy();

    const trackSystemModel = document.getElementById('trackSystemModel');
    if (!this.trackSystemAutocomplete) {
      const _this = this;
      this.trackSystemAutocomplete = autocomplete({
        container: trackSystemModel,
        placeholder: trackSystemModel.dataset.placeholder,
        openOnFocus: true,
        getSources({ query }) {
          return fetch(
            `/api/exploded-view/track-system?q=${query}`
          )
            .then((response) => response.json())
            .then(({ data }) => {
              return [
                {
                  sourceId: 'data',
                  getItems() {
                    return data;
                  },
                  getItemInputValue({ item }) {
                    return item.title;
                  },
                  onSelect({ item, setQuery }) {
                    setQuery(item.title);
                    _this._fetchAssemblies(item.title);
                    _this.trackSystemAutocomplete.setIsOpen(false);
                    _this.partNumberAutocomplete.setQuery('');
                    _this.selectedModel = _this._getModelName(item.title);
                    _this.modelSelect.value = _this.selectedModel;
                    const selectedOption = _this.modelSelect.options[_this.modelSelect.selectedIndex];
                    _this.currentYears = JSON.parse(selectedOption.dataset.years || '[]');
                    _this.$nextTick(() => {
                      _this.yearSelect.value = item.title;
                    });

                    _this.modelQuery = item.title;
                    _this.partQuery = '';
                  },
                  templates: {
                    item({ item }) {
                      return item.title;
                    },
                  }
                },
              ];
            });
        },
      });
    }

    const partNumber = document.getElementById('partNumber');
    if (!this.partNumberAutocomplete) {
      const _this = this;
      this.partNumberAutocomplete = autocomplete({
        container: partNumber,
        placeholder: partNumber.dataset.placeholder,
        openOnFocus: true,
        getSources({ query }) {
          return fetch(
            `/api/exploded-view/part-number?q=${query}`
          )
            .then((response) => response.json())
            .then(({ data }) => {
              return [
                {
                  sourceId: 'data',
                  getItems() {
                    return data;
                  },
                  getItemInputValue({ item }) {
                    return item.title;
                  },
                  onSelect({ item, setQuery }) {
                    // setQuery(item.title);
                    // window.location.href = item.url;
                    _this._fetchPartAssemblies(item.title);
                    _this.currentQuery = _this.partQuery = item.title;
                    _this.partNumberAutocomplete.setIsOpen(false);
                    _this.trackSystemAutocomplete.setQuery('');
                    _this.selectedModel = null;
                    _this.modelQuery = '';
                    _this.modelSelect.value = '';
                  },
                  templates: {
                    item({ item }) {
                      return item.title;
                    },
                  }
                },
              ];
            });
        },
        onStateChange({ state }) {
          if (state.isOpen === false && state.query === '' && _this.modelQuery === '' && !_this.loading) {
            _this.partQuery = '';
            _this.currentQuery = '';
            _this.part = null;
            _this.assemblies = [];
          }
        }
      });
    }

    document.addEventListener('click', (event) => {
      const autocompleteContainer = trackSystemModel.querySelector('.aa-Autocomplete');
      if (autocompleteContainer && !autocompleteContainer.contains(event.target)) {
        this.trackSystemAutocomplete.setIsOpen(false);
      }
    });

  },
  _fetchAssemblies(model) {
    this.loading = true;
    let query = model;
    this.assemblies = [];
    this.part = null;
    this.currentQuery = this.modelQuery = query;

    fetch(`/api/exploded-view/track-system/assemblies?q=${query}`)
      .then((response) => response.json())
      .then(({ data }) => {
        if (data.length > 0) {
          this.assemblies = data[0].assemblies;
          this.loading = false;
          if(!this.selectedModel){
            this.selectedModel = this._getModelName(model);
          }

          this.listTitle = this.selectedModel + " " + 
            this.yearSelect.options[this.yearSelect.options.selectedIndex].text + 
            " " + "("  + this.currentQuery + ")";
        } else {
          alert('No results found for the selected model and year.');
        }
      });
  },
  _fetchPartAssemblies(partNumber) {
    this.loading = true;
    this.assemblies = [];

    fetch(`/api/exploded-view/part-number/assemblies?q=${partNumber}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.title) {
          this.part = data.part;
          this.assemblies = data.assemblies;
          this.loading = false;
          this.partNumberAutocomplete.setQuery(data.partNumber);
          
          this.listTitle = this.part ? this.$refs.listtitle.dataset.defaultLabel : data.title;
          if(this.part){
            setTimeout(() => {
              const cartbtn = this.$refs.cartbtn;
              cartbtn.setAttribute('data-default-variant-id', this.part.shopifyProductVariantId);
              cartbtn.setAttribute('data-product-title', this.part.title);
              cartbtn.setAttribute('data-product-number', this.part.partNumber);
              cartbtn.setAttribute('data-product-price', this.part.price.amount/100);

            }, 100);            
          }


        } else {
          alert('No results found for the selected model and year.');
        }
      });
  },
  _destroy() {
    if (this.trackSystemAutocomplete) {
      this.trackSystemAutocomplete.destroy();
      this.trackSystemAutocomplete = null;
    }
    if (this.partNumberAutocomplete) {
      this.partNumberAutocomplete.destroy();
      this.partNumberAutocomplete = null;
    }

    const containers = ['trackSystemModel', 'partNumber'];
    containers.forEach(id => {
      const container = document.getElementById(id);
      if (container) {
        const autocompleteEl = container.querySelector('.aa-Autocomplete');
        if (autocompleteEl) {
          autocompleteEl.remove();
        }
      }
    });
  },
});
